import { useT, SUPPORTED_LANGS } from "@/lib/i18n";

/**
 * Compact pill-style language switcher (NL · EN). Usable both on dark
 * surfaces (sidebar) and light ones (landing page) — pass `variant`.
 */
export default function LanguageSwitcher({ variant = "light", className = "" }) {
  const { lang, setLang, t } = useT();

  const base =
    "inline-flex items-center rounded-full border text-[11px] font-bold uppercase tracking-[0.15em] overflow-hidden";
  const wrapCls =
    variant === "dark"
      ? "border-[#3D4D41] bg-[#1A1D1A]/40"
      : "border-[#E5E2DC] bg-white";

  const btn = (active) =>
    `px-2.5 py-1.5 transition-colors ${
      active
        ? variant === "dark"
          ? "bg-[#4A5D4E] text-white"
          : "bg-[#4A5D4E] text-white"
        : variant === "dark"
        ? "text-[#D6D7D3] hover:bg-[#3D4D41]"
        : "text-[#5C635A] hover:bg-[#F2F0EA]"
    }`;

  return (
    <div
      className={`${base} ${wrapCls} ${className}`}
      role="group"
      aria-label={t("lang.switcher.label")}
      data-testid="language-switcher"
    >
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          className={btn(lang === code)}
          data-testid={`lang-btn-${code}`}
          aria-pressed={lang === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
